const MyResults = () => {

	var exercises:string[] = ['2to5', '6to9', '2to9', '6to12', '2to12'];


	function clearResults() {
		console.log('test');
		for (let i in exercises) {
			console.log(i);
			window.localStorage.removeItem(exercises[i]+'_bestScoreWithErrors');
			window.localStorage.removeItem(exercises[i]+'_bestScoreWithoutErrors');
		}
		window.location.reload();
	}
	var recordsCount:number = 0;
	var testExercises = exercises.map((exercise)=>{
		var bestScoreWithErrors:any = window.localStorage.getItem(exercise+'_bestScoreWithErrors');
		var bestScoreWithoutErrors:any = window.localStorage.getItem(exercise+'_bestScoreWithoutErrors');
		var arr:object[] = [];

		if (bestScoreWithoutErrors !==null) {
			bestScoreWithoutErrors = JSON.parse(bestScoreWithoutErrors);
			arr.push(<p style={{color:'green'}} key={exercise+'_withoutErrors'}>In {exercise} your best result without errors is : {bestScoreWithoutErrors.correctAnswers}</p>);
			recordsCount++;
		}

		if (bestScoreWithErrors !== null) {
			bestScoreWithErrors = JSON.parse(bestScoreWithErrors);
			arr.push(<p key={exercise+'_withErrors'}>In {exercise} your best result with errors is : {bestScoreWithErrors.correctAnswers}</p>);
			recordsCount++;
		}

		return arr;
	});
	console.log(testExercises)

	return (
		<>
			<h2 className="d-flex justify-content-center">My Results</h2>
			<div className="text-center">
				{testExercises}
				{recordsCount === 0 &&
					<p>no results yet </p>
				}
				
			</div>
			<div
			 className="text-center mt-4">
				<button onClick={()=>{clearResults()}} className="btn btn-outline-danger">Clear My Results</button>
				<br />
				<br />
				<a className="btn btn-outline-success" href="./" role="button">Back To Menu</a>
			</div>
		</>
	)
}

export default MyResults;

//my results best results for 2 to 5 or best results for 6 to 9 or best results 2 to 9 and best results for 6 to 12.
